<script setup>
import { onMounted, ref } from "vue";
const { format, subDays  } = require("date-fns");
import { FilterMatchMode } from '@primevue/core/api';
import MiniStatisticsCard from "@/components/Cards/MiniStatisticsCard.vue";
import { pVentasRequest, typeInvoicesRequest, invoicesRequest } from '../api/invoices';
import { ExportExcelRequest } from '../api/utils';
import { municipality } from '../api/technicalAnnex';
import { decrypt } from '../utils/crypto.js'

import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import ConfirmDialog from 'primevue/confirmdialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Select from 'primevue/select';
import DatePicker from 'primevue/datepicker';
import Button from 'primevue/button';

import { useConfirm } from "primevue/useconfirm";
const confirm = useConfirm();

// Fecha actual 
const today = new Date();
const formattedToday = format(today, "MM/dd/yyyy");

// Fecha del día anterior
const yesterday = subDays(today, 1);
const formattedYesterday = format(yesterday, "MM/dd/yyyy");

const dataSource = ref([]);
const typeA = ref('0');
const typeB = ref('0');
const pventas = ref([]);
const selectedPventa = ref('');
const activeSpinner = ref(false)
const activeSpinnerExcel = ref(false)
const data_from = ref(formattedYesterday);
const data_to = ref(formattedToday);
const columns = [
  { field: 'nombre', header: 'Pventa' },
  { field: 'facturador', header: 'Facturador' },
  { field: 'nombre_archivo', header: 'Factura' },
  { field: 'fecha_timbrado', header: 'Fecha' },
  { field: 'hora_timbrado', header: 'Hora' },
  { field: 'type_int', header: 'Tipo' },
];

//ObjetsArray Municipios && Departamentos
const munDep = ref([]);
const municipalities = ref([]);
const departments = ref([]);
const selectedDeparment = ref(null);
const selectedCodeDeparment = ref(null);
const selectedMunicipaly = ref(null);
const selectedCodeMunicipaly = ref(null);

const formatDate = (date) => {
  if (date != undefined) {
    const fecha = new Date(date);
    return format(fecha, "yyyy-MM-dd");
  }else {
    return null;
  }
}

const filters = ref({
  'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const resetFilter = () => {
  data_from.value = null;
  data_to.value = null;
  selectedPventa.value = '';
  selectedDeparment.value = null;
  selectedCodeDeparment.value = null;
  selectedMunicipaly.value = null;
  selectedCodeMunicipaly.value = null;
  loadInfo();
}

const loadInfo = async() => {
  const permissions = localStorage.getItem('setPrm');
  const decryptpermissions = !permissions ? 0 : JSON.parse(decrypt(permissions));
  const date_from = formatDate(data_from.value);
  const date_to = formatDate(data_to.value);
  let data = { 
    date_from , 
    date_to, 
    pventa: selectedPventa.value, 
    invoicer: selectedPventa.value, 
    permissions :decryptpermissions,
    codeDepartment : selectedCodeDeparment.value,
    codeMunicipaly: selectedCodeMunicipaly.value
  }
  await loadInvoicesTypes(data);
  await loadInvoices(data);
}

const loadNameByPventa = async () => {
  try {
    let data = {department : selectedCodeDeparment.value,municipality: selectedCodeMunicipaly.value}
    let result = await pVentasRequest(data)
    pventas.value = result.data.data;
  } catch (error) {
    console.log(error);
  }
}

const loadInvoicesTypes = async (data) => {
  typeA.value = 0;
  typeB.value = 0;
  try {
    let result = await typeInvoicesRequest(data);
    typeA.value = '$ ' + result.data.totalTypeA.toLocaleString();
    typeB.value = '$ ' + result.data.totalTypeB.toLocaleString();
  } catch (error) {
    console.log(error);
  }
}

const loadInvoices = async (data) => {
  activeSpinner.value = true;
  try {
    let result = await invoicesRequest(data);
    dataSource.value = result.data.data;
    activeSpinner.value = false;
  } catch (error) {
    console.log(error);
  }
}

const showCufe = (data) => {
  confirm.require({
      message: data.cufe,
      header: 'CUFE',
      icon: 'pi pi-bookmark-fill',
      acceptProps: {
          label: 'Consultar Dian'
      },
      rejectProps: {
          label: 'Close',
          severity: 'danger'
      },
      accept: () => {
        const url = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${data.cufe}`
        window.open(url, '_blank');
      }       
  });
};

const exportToExcel = async () => {
  activeSpinnerExcel.value = true;
  try {
    const data = dataSource.value;
    const response = await ExportExcelRequest(data);
    const blob = new Blob([response.data]);
    const elink = document.createElement("a");
    elink.download = 'Invoicings.xlsx';
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    document.body.removeChild(elink)
    activeSpinnerExcel.value = false;
  } catch (error) {
    console.log(error);
    activeSpinnerExcel.value = false;
  }
}

const department = () => {
  departments.value = munDep.value.reduce((acc, curr) => {
    const existing = acc.find(item => item.departamento === curr.nombre_departamento);
    return existing ? acc : [...acc, { codigo: curr.codigo_departamento, departamento: curr.nombre_departamento }];
  }, []);
}

const loadMucipaly = async () => {
  let municipalitiesAndDepartments = await municipality();
  munDep.value = municipalitiesAndDepartments.data.data;
  department();
}

const municipalityAndCode = () => {
  selectedCodeDept();
  selectedCodeMunicipaly.value = null;
  municipalities.value = [];
  const code = selectedCodeDeparment.value
  municipalities.value = munDep.value
  .filter(item => item.codigo_departamento === code)
  .map(item => ({
    codigo: item.codigo_municipio,
    municipio: item.nombre_municipio
  }));
  loadNameByPventa();
}

const selectedCodeDept = () => {
  let code = selectedDeparment.value.codigo != undefined ? selectedDeparment.value.codigo : selectedDeparment.value;
  selectedCodeDeparment.value =  code
}

const selectedCodeMun = () => {
  let code = selectedMunicipaly.value.codigo != undefined ? selectedMunicipaly.value.codigo : selectedMunicipaly.value;
  selectedCodeMunicipaly.value = code;
}

onMounted(() => {
  loadNameByPventa();
  loadInfo();
  loadMucipaly();
});

</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row justify-content-center">
          <ConfirmDialog></ConfirmDialog>
          <div class="col-lg-12 col-md-6 col-12">
            <div class="mb-3 card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <label for="selectedDeparment" class="form-label">Departamento</label>
                    <Select  v-model="selectedDeparment" @change="municipalityAndCode" :options="departments" filter optionLabel="departamento" class="form-select form-select-sm" />
                  </div>
                  <div class="col-md-4">
                    <label for="selectedMunicipaly" class="form-label">Municipio</label>
                    <Select  v-model="selectedMunicipaly" @change="selectedCodeMun" :options="municipalities" filter optionLabel="municipio" class="form-select form-select-sm" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Punto De Venta</label>
                    <Select  v-model="selectedPventa" :options="pventas" filter optionValue="nombre" optionLabel="nombre" class="form-select form-select-sm" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Fecha Inicio</label><br>
                    <DatePicker class="input" v-model="data_from" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Fecha Final</label><br>
                    <DatePicker class="input" v-model="data_to" />
                  </div>
                  <div class="col-md-4">
                    <button class="btn btn-link mt-4 py-3" @click="loadInfo">
                      <i class="fa fa-search" aria-hidden="true" />
                    </button>
                    <button class="btn btn-link mt-4 py-3" @click="resetFilter">
                      <i class="fa fa-refresh" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="FE - Tipo A" :value="typeA" :icon="{
              component: 'ni ni-money-coins',
              background: 'bg-gradient-success',
              shape: 'rounded-circle',
            }" />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="FE - TIPO B" :value="typeB" :icon="{
              component: 'ni ni-money-coins',
              background: 'bg-gradient-primary',
              shape: 'rounded-circle',
            }" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mb-lg">
            <div class="card z-index-2">
              <div class="d-flex flex-row m-4">
                <div class="col-md-3">
                  <IconField>
                    <InputIcon>
                      <i class="pi pi-search" />
                    </InputIcon>
                    <InputText class="" v-model="filters['global'].value" placeholder="Keyword Search" />
                  </IconField>
                </div>
                <div>
                  <button :disabled="activeSpinnerExcel" class="btn btn-success" @click="exportToExcel">Descargar Excel</button>
                </div>
                <div v-if="activeSpinnerExcel" class="flex justify-content-center px-2 py-1 align-items-center text-center">
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                </div>
              </div>
              <div class="col-lg-12 mb-lg-0 mb-4">
                <div class="card">
                  <div class="mt-3 px-2">
                    <div v-if="activeSpinner" class="flex justify-content-center align-items-center text-center mb-5">
                      <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
                    </div>
                    <DataTable 
                      v-if="!activeSpinner"
                      class="m-3" 
                      :value="dataSource" 
                      :paginator="true" 
                      :rows="5"
                      :rowsPerPageOptions="[5, 10, 20, 50]" 
                      :filters="filters"
                      stripedRows 
                      resizableColumns 
                      columnResizeMode="fit" 
                      showGridlines 
                      tableStyle="min-width: 50rem"
                    >
                      <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header" sortable></Column>
                      <Column :exportable="false" style="min-width: 1rem">
                        <template #body="slotProps">
                            <Button icon="pi pi-eye" outlined rounded class="mr-2" title="CUFE" severity="info" @click="showCufe(slotProps.data)" />
                        </template>
                      </Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>

.input {
  height: 3rem !important;
  width: 100%;
}
</style>